import classnames from 'classnames';
import { useEffect, useRef } from 'react';
import AnimateHeight, { type AnimateHeightProps } from 'react-animate-height';
import Icon from '../icons/Icon';
import './error-label.scss';
import { FCC } from '../../../utils/types';

interface Props {
  id?: string;
  hasError: boolean;
  typography?: 'body-text' | 'sub-body' | 'metadata';
  focusOnError?: boolean;
}
const ErrorLabel: FCC<Props> = ({ id = undefined, hasError, children, typography = 'body-text', focusOnError = false }) => {
  const ref = useRef<HTMLDivElement>(null);

  const errorAnimateOptions: AnimateHeightProps = {
    duration: 100,
    animateOpacity: true,
    height: hasError ? 'auto' : 0,
    'aria-hidden': !children,
  };
  const classes = classnames('error-label', typography);

  useEffect(() => {
    if (focusOnError && hasError) {
      ref?.current?.focus();
    }
  }, [hasError, focusOnError]);

  return (
    <AnimateHeight {...errorAnimateOptions}>
      <div ref={ref} className={classes} id={id} tabIndex={-1}>
        {children && (
          <Icon type="alertTriangle" className="error-label__icon" fill="currentColor" aria-hidden="true" />
        )}
        {children}
      </div>
    </AnimateHeight>
  );
};

export default ErrorLabel;
